import { render, staticRenderFns } from "./policyBanner.vue?vue&type=template&id=eaf3159c&scoped=true"
import script from "./policyBanner.vue?vue&type=script&lang=js"
export * from "./policyBanner.vue?vue&type=script&lang=js"
import style0 from "./policyBanner.vue?vue&type=style&index=0&id=eaf3159c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf3159c",
  null
  
)

export default component.exports